import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/core/services';


@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {

    constructor( private router: Router, private authService: AuthService) 
    { 
        
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authService.currentUserValue;
        console.log(state.url, currentUser);

        if(state.url == '/') {

            if (!currentUser) {
                this.router.navigate(['/login']);
                return false;
            }
            else {
                this.router.navigate(['/welcome']);
                return false;
            }

        }
        else if (state.url == '/login') {

            if (currentUser) {
                this.router.navigate(['/']);
                return false;
            }

        }

        return true;
    }    

}